const clientEndpoints = {
  CLIENTS: 'loopay-client-management/clients',
  VIEW_CLIENT: (clientId: string) =>
    `loopay-client-management/clients/${clientId}`,
  // For updating DRAFT clients during add/draft flow
  EDIT_DRAFT_CLIENT: (clientId: string) =>
    `loopay-client-management/clients/${clientId}`,
  // For updating ACTIVE clients during edit flow
  EDIT_ACTIVE_CLIENT: (clientId: string) =>
    `loopay-client-management/clients/${clientId}/edit`,
  FINALIZE: (clientId: string) =>
    `loopay-client-management/clients/${clientId}/create`,
  CLIENT_STATUS: (clientId: string) =>
    `loopay-client-management/clients/${clientId}/status`,
  PRESIGNED_URLS_BATCH: 'loopay-media-management/media/presigned-urls/batch',
  MEDIA_RESOURCES: 'loopay-media-management/media/resources',
} as const;

export default clientEndpoints;
